// Firebase Authentication service for admin login
import { 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged, 
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider
} from 'firebase/auth';
import { auth } from './config';

export const authService = {
  // Sign in with email and password
  async signInAdmin(email, password) {
    try {
      console.log('Attempting admin sign in...');
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      console.log('Admin signed in successfully:', user.email);
      return { success: true, user };
    } catch (error) {
      console.error('Admin sign in failed:', error);
      return { success: false, error: error.message };
    }
  },

  // Sign in with Google
  async signInWithGoogle() {
    try {
      console.log('Attempting Google sign in...');
      const provider = new GoogleAuthProvider();
      const userCredential = await signInWithPopup(auth, provider);
      const user = userCredential.user;
      console.log('Google sign in successful:', user.email);
      return { success: true, user };
    } catch (error) {
      console.error('Google sign in failed:', error);
      return { success: false, error: error.message };
    }
  },

  // Sign out admin
  async signOutAdmin() {
    try {
      await signOut(auth);
      console.log('Admin signed out successfully');
      return { success: true };
    } catch (error) {
      console.error('Admin sign out failed:', error);
      return { success: false, error: error.message };
    }
  },

  // Create admin user (run this once to set up admin account)
  async createAdminUser(email, password) {
    try {
      console.log('Creating admin user...');
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      console.log('Admin user created successfully:', user.email);
      return { success: true, user };
    } catch (error) {
      console.error('Admin user creation failed:', error);
      return { success: false, error: error.message };
    }
  },

  // Listen to auth state changes
  onAuthStateChange(callback) {
    return onAuthStateChanged(auth, callback);
  },

  // Get current user
  getCurrentUser() {
    return auth.currentUser;
  },

  // Check if user is authenticated
  isAuthenticated() {
    return !!auth.currentUser;
  }
};
